import styled from "styled-components";
import { DashboardPageContainer } from "../components/dashboardPageContainer.styled";

const AnalyticsPage = () => {
    return (
        <DashboardPageContainer>
            <Content>
                <iframe
                    width="100%"
                    height="100%"
                    src="https://datastudio.google.com/embed/reporting/8773cc57-a3fe-4ece-8c65-12c17c4e3d85/page/4VDGB"
                    style={{ border: 0 }}
                    allowFullScreen
                    title="google-analytics"
                />
            </Content>
        </DashboardPageContainer>
    );
};

const Content = styled.div`
    padding: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;

    & > *:first-child {
        margin-bottom: 20px;
    }

    @media (max-width: 768px) {
        padding: 0;
    }
`;

export default AnalyticsPage;
